import { useContext } from 'react';
import { CardContext } from '../../utils/cardContext';
import { Builder as BuilderComponent } from '../../components/Builder';

export const Builder = () => {
  const layout = useContext(CardContext);

  return <BuilderComponent builders={layout.builders} newbuildingId={layout.id} />;
};
